
import Factory from "@/store/modules/system/factory/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins} from "@/lib";

@Component
export default class EditFactory extends Mixins(FormModalMixins) {
  model = new Factory();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Edit",labelWidth:100, okAction: "system/factory/update" });
  }
 get record(){
        return this.$store.state.system.factory.editFactory;
    }
}
